// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"aef5481376ca15415b14","655":"b537eae87719da7cbfba"}[chunkId] + ".js";
};